import { reducer as webPushReducer } from './webPush.slice';

export default webPushReducer;
